import {
  ChartIcon,
  ScaleIcon,
  BuildingIcon,
  GlobeIcon,
  LightbulbIcon,
  ResearchIcon,
} from "../GlobalResearch/icon2";

import {
  IconChart,
  IconBuilding,
  IconGlobe,
  IconBook,
} from "../GlobalResearch/icons.jsx";

export const focusAreas = [
  {
    icon: ChartIcon,
    title: "Research for Economic Development",
    body: "Strengthening manufacturing, trade, investment and financial systems to enhance India's growth path.",
  },
  {
    icon: ScaleIcon,
    title: "Public Policy Analysis",
    body: "Actionable insights on national, state and global developments for evidence-based decision-making.",
  },
  {
    icon: BuildingIcon,
    title: "Ease of Doing Business",
    body: "Research-backed strategies that foster innovation, improve market access and support businesses.",
  },
  {
    icon: GlobeIcon,
    title: "Trade & Investment Promotion",
    body: "Strategic intelligence for India's high-growth sectors and stronger global partnerships.",
  },
  {
    icon: LightbulbIcon,
    title: "Industry-Academia Collaboration",
    body: "Connections that promote research, innovation and employment creation across the economy.",
  },
];



export const initiatives = [
  {
    icon: IconChart,
    title: "Economic Growth & Development",
    body: "Economic Growth & Development is a flagship research initiative of the ASSOCHAM Global Research & Strategy Centre dedicated to advancing evidence-based policy research on India's economic transformation. Through analytical reports, working papers, and thematic studies, the initiative examines the Indian economic and policy landscape. Through actionable insights on national, state, and global economic developments, the initiative contributes to strengthening India's competitiveness and fostering sustainable and inclusive economic development.",
    buttonText: "Explore Reports",
    to: "/global-research/economic-growth",
  },
  {
    icon: IconBuilding,
    title: "Ease of Doing Business (EoDB)",
    body: "The Ease of Doing Business (EoDB) initiative supports the creation of a more efficient, transparent, and business-friendly regulatory environment through research, policy analysis, and stakeholder engagement. It develops deregulation studies, policy ready reckoners, sector-specific reports, and knowledge resources that help businesses better understand regulatory frameworks and market opportunities. The initiative also organises consultations, conferences, and dialogues to facilitate collaboration between government, industry, and experts.",
    buttonText: "Learn More",
    to: "/global-research/eodb",
  },
  {
    icon: IconGlobe,
    title: "Trade & Investment Promotion Services (TIPS)",
    body: "Trade & Investment Promotion Services (TIPS) is a flagship initiative of the ASSOCHAM Global Research & Strategy Centre that serves as a dedicated information and advisory platform for trade and investment. It provides businesses, investors, and government institutions with strategic insights into high-growth sectors, investment opportunities, and the evolving policy and regulatory landscape. By facilitating knowledge sharing, institutional partnerships, and stakeholder engagement, TIPS supports informed investment decisions and promotes domestic and international business collaborations.",
    buttonText: "Visit TIPS",
    to: "/global-research/tips",
  },
  {
    icon: IconBook,
    title: "Publications",
    body: "The Publications vertical disseminates timely research and economic intelligence to support informed decision-making across government, industry, academia, and the wider business community. It offers regular analysis of macroeconomic trends, policy developments, sectoral performance, business indicators, and the global economic outlook through a range of flagship publications.",
    bullets: [
      "ASSOCHAM Business Currents Daily (ABC Daily)",
      "ASSOCHAM India Monitor (AIM Weekly)",
      "ASSOCHAM Global Economic Outlook (ASSOCHAM GEO Monthly)",
    ],
    buttonText: "View Publications",
    to: "/global-research/publications",
  },
];

export const team = [
  {
    name: "Dr. S.P. Sharma",
    role: "Chief Economist",
    photo: "https://images.pexels.com/photos/3777946/pexels-photo-3777946.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Ms. Ruchi Singhal",
    role: "Additional Director",
    photo: "https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Ms. Yatika Gupta",
    role: "Joint Director",
    photo: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Mr. Arun Singh Rathore",
    role: "Deputy Director",
    photo: "https://images.pexels.com/photos/532220/pexels-photo-532220.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];
